var render = function render(_c,_vm){return _c('div',{staticClass:"top-section",class:_vm.data.staticClass},[_vm._t("header-wrapper",function(){return [_c('h2',{staticClass:"section-header text-uppercase top-section__header"},[_vm._t("header")],2)]}),_vm._v(" "),(_vm.slots().text)?_c('p',{staticClass:"section-text"},[_vm._t("text")],2):_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }